import { fmt } from "@/lib/format";

export default function ModelBreakdown({ byModel }) {
  return (
    <section className="rounded-xl bg-white p-4 shadow-[0_1px_2px_rgba(15,23,42,0.04),0_4px_12px_-6px_rgba(15,23,42,0.08)]">
      {!byModel || byModel.length === 0 ? (
        <div className="text-sm text-ink-400">데이터 없음</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-ink-200 text-sm">
            <thead className="bg-ink-50">
              <tr>
                <Th>모델</Th>
                <Th>등급</Th>
                <Th align="right">호출 수</Th>
                <Th align="right">크레딧 사용</Th>
                <Th align="right">Cache hit</Th>
              </tr>
            </thead>
            <tbody className="divide-y divide-ink-100">
              {byModel.map((r) => (
                <tr key={r.modelId}>
                  <Td className="font-mono text-xs">{r.modelId}</Td>
                  <Td>{r.tier}</Td>
                  <Td align="right" className="tabular-nums">{fmt.int(r.requestCount)}</Td>
                  <Td align="right" className="tabular-nums">{fmt.nc(r.ncUsed)}</Td>
                  <Td align="right" className="tabular-nums">{((r.cacheHitRate ?? 0) * 100).toFixed(1)}%</Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}

function Th({ children, align = "left" }) {
  return (
    <th className={`px-3 py-2 text-${align} text-xs font-semibold uppercase tracking-wide text-ink-500`}>
      {children}
    </th>
  );
}

function Td({ children, align = "left", className = "" }) {
  return <td className={`px-3 py-2 text-${align} ${className}`}>{children}</td>;
}
